import TableActions from './tableActions';

export default TableActions;
